import { PropsWithChildren } from "react";

import { WithDataComponent } from "../types";

type DivProps = {
  className?: string;
  onClick?: () => void;
  dataComponent?: string;
};

/**
 * Div with flexbox styling. This occurs so much across our code that it made
 * sense to implement this component for readability.
 *
 * @prop className - If provided, applies additional style classes to the div.
 * @prop onClick - Optional onClick behavior for the div.
 * @prop dataComponent - If specified, serves as the data-component value for the component.
 */
export const HDiv = ({
  className,
  children,
  onClick,
  "data-component": dataComponent,
}: PropsWithChildren<WithDataComponent<DivProps>>) => (
  <div
    className={`flex ${className}`}
    onClick={onClick}
    data-component={dataComponent}
  >
    {children}
  </div>
);

/**
 * Div with flexbox styling. This occurs so much across our code that it made
 * sense to implement this component for readability.
 *
 * @prop className - If provided, applies additional style classes to the div.
 * @prop onClick - Optional onClick behavior for the div.
 * @prop dataComponent - If specified, serves as the data-component value for the component.
 */
export const VDiv = ({
  className,
  children,
  onClick,
  "data-component": dataComponent,
}: PropsWithChildren<WithDataComponent<DivProps>>) => {
  return (
    <div
      className={`flex flex-col ${className}`}
      onClick={onClick}
      data-component={dataComponent}
    >
      {children}
    </div>
  );
};
